/**
 * The plain "Default value" input — the no-scope view, unchanged.
 * For Media Devoted | Created By Ciro Autiero
 *
 * Kept byte-identical to what shipped before the scope feature: this is the
 * control every existing rule form test and every user's muscle memory expects.
 */

import type { FC } from 'react';

import { Input } from '@/components/ui';

export const DefaultValueField: FC<{
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}> = ({ value, onChange }) => (
  <div>
    <label
      className="mb-1 block text-xs font-medium text-muted-foreground"
      title="The number the metric is compared against, for every country unless overridden below."
    >
      Default value
    </label>
    <Input
      type="number"
      value={value}
      onChange={onChange}
      className="h-9 w-full min-w-[80px]"
      aria-label="Default value (all countries unless overridden below)"
      placeholder="0"
    />
  </div>
);
